import { withMargins, withPaddings, withSize, withBorders, withColors, withLayout, withPosition, } from './utils';
import { createUseStyles } from 'react-jss';
export const createBoxStyles = (props) => ({
    // to ensure padding is included in width
    boxSizing: 'border-box',
    display: props.display,
    ...withMargins(props),
    ...withPaddings(props),
    ...withSize(props),
    ...withBorders(props),
    ...withColors(props),
    ...withLayout(props),
    ...withPosition(props),
});
export const useBoxClasses = createUseStyles({
    box: createBoxStyles,
});
